import TOC_TYPES from '../../constants/tocTypes';

export default function getTocItemLabelFromType(itemType) {
  switch (itemType) {
    case TOC_TYPES.SUBTITLE:
      return 'chapter';

    case TOC_TYPES.MCQ:
      return 'mcq';

    default:
      return 'chapter';
  }
}
